import { Base } from '../base';
import { Tariff, Scheduler, RegisterParkingLot, ParkingLot, RegisterTariff } from '../../entity';
import { Address } from './address';

export class RegisterParking extends Base {
    ParkingID?: number;
    ParkingTypeID?: number;
    ParkingLevelID?: number;
    CompanyID?: number;
    PublicInstitutionID?: number;
    Title?: string;
    Phone?: string;
    Email?: string;
    Address?: string;
    Location?: string;
    Latitude?: number;
    Longitude?: number;
    NoLots?: number;
    HasSensors?: boolean;

    OwnerName?: string;
    OwnerPhone?: string;
    OwnerEmail?: string;

    ContactName?: string;
    ContactPhone?: string;
    ContactEmail?: string;

    LotGenerationList?: Array<RegisterParkingLot>;
    SensorLotList?: Array<ParkingLot>;
    Tariffs?: Array<Tariff | RegisterTariff>;
    Scheduler?: Array<Scheduler>;

    // Constructors
    constructor(
        parkingTypeId?: number,
        parkingLevelId?: number,
        companyId?: number,
        publicInstitutionId?: number,
        title?: string,
        phone?: string,
        email?: string,
        address?: string,
        location?: string,
        latitude?: number,
        longitude?: number,
        noLots?: number,
        hasSensors?: boolean,
        ownerName?: string,
        ownerPhone?: string,
        ownerEmail?: string,
        contactName?: string,
        contactPhone?: string,
        contactEmail?: string,
        lotGenerationList?: Array<RegisterParkingLot>,
        sensorLotList?: Array<ParkingLot>,
        tariffs?: Array<RegisterTariff | Tariff>,
        scheduler?: Array<Scheduler>

    ) {
        super();
        this.ParkingTypeID = parkingTypeId;
        this.ParkingLevelID = parkingLevelId;
        this.CompanyID = companyId;
        this.PublicInstitutionID = publicInstitutionId;
        this.Title = title;
        this.Phone = phone;
        this.Email = email;
        this.Address = address;
        this.Location = location;
        this.Latitude = latitude;
        this.Longitude = longitude;
        this.NoLots = noLots;
        this.HasSensors = hasSensors;
        this.OwnerName = ownerName;
        this.OwnerPhone = ownerPhone;
        this.OwnerEmail = ownerEmail;
        this.ContactName = contactName;
        this.ContactPhone = contactPhone;
        this.ContactEmail = contactEmail;
        this.LotGenerationList = lotGenerationList;
        this.SensorLotList = sensorLotList;
        this.Tariffs = tariffs;
        this.Scheduler = scheduler;
    }
}
